'use client';

import Image from 'next/image';
import type { ReactNode } from 'react';
import { requestPdMeasurement } from '../request.client';
import type { PdMeasurementRequestHandler, PrescriptionPdMeasurementRisk } from '../types';

interface PrescriptionPdMeasurementActionProps {
  label: string;
  onMeasure?: PdMeasurementRequestHandler;
  prescriptionRisk?: PrescriptionPdMeasurementRisk;
}

const RULER_ICON_SRC = '/zeelool-next/lens-measurement/ruler.svg';

export function PrescriptionPdMeasurementAction({
  label,
  onMeasure,
  prescriptionRisk = 'standard',
}: PrescriptionPdMeasurementActionProps) {
  const handleClick = () => {
    const request = {
      kind: 'pd' as const,
      source: 'lens-prescription-pd' as const,
      prescriptionRisk,
    };
    if (onMeasure) {
      onMeasure(request);
      return;
    }

    requestPdMeasurement(request.source, window, request.prescriptionRisk);
  };

  return (
    <button
      type="button"
      className="flex cursor-pointer items-center gap-[4px] border-0 bg-transparent p-0 text-[12px] leading-[14px] text-primary-purple underline underline-offset-2"
      onClick={handleClick}
    >
      <Image
        alt=""
        aria-hidden
        className="h-[16px] w-[16px] shrink-0"
        src={RULER_ICON_SRC}
        width={16}
        height={16}
      />
      <span>{label}</span>
    </button>
  );
}

interface PrescriptionPdHistoryNoticeProps {
  children: ReactNode;
}

export function PrescriptionPdHistoryNotice({ children }: PrescriptionPdHistoryNoticeProps) {
  return (
    <div
      role="status"
      className="w-full whitespace-pre-line rounded-[4px] bg-[#fff9d7] p-[8px] text-[11px] leading-[normal] text-primary-black"
    >
      {children}
    </div>
  );
}
